import { Collapse } from 'antd';
import AC from '../AccessControl';
import Thumbnail from '../ui/Thumbnail';
import styles from './ThumbnailView.module.scss';
const ThumbnailView = ({
  contentData,
  activeKeys,
  setActiveKeys
}) => <div className="library-grid" data-sentry-component="ThumbnailView" data-sentry-source-file="ThumbnailView.jsx">
  {contentData.map(datum => datum.type === 'group' ? <Collapse key={datum.key} bordered={false} className={styles["thumbanail-view-collapse"]} activeKey={activeKeys} onChange={setActiveKeys}>
        <Collapse.Panel key={datum.key} header={datum.name} className={styles["thumbanail-view-collapse-panel"]} showArrow>
          <ThumbnailView contentData={datum.children} activeKeys={activeKeys} setActiveKeys={setActiveKeys} />
        </Collapse.Panel>
      </Collapse> : <Thumbnail key={datum.key} data={datum} language={datum.linkedLanguage} link={{
    pathname: `/toolkits/${datum.type}/[slug]`,
    query: {
      slug: datum.slug
    }
  }} />)}
  </div>;
export default ThumbnailView;